// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInCalendarYears as fn } from "../differenceInCalendarYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInCalendarYearsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInCalendarYearsWithOptions;
